import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { FormFieldDropdown } from '~/components/FormField';
import { useDealOwnerList } from '~settings/api/queries/dealOwnersList';
import { toDropdownList } from '~settings/utils/transformers';

interface SelectDealOwnerProps
  extends Omit<ComponentProps<typeof FormFieldDropdown>, 'label' | 'options'>,
    Partial<Pick<ComponentProps<typeof FormFieldDropdown>, 'label'>> {}

export function SelectDealOwner({ name, ...props }: SelectDealOwnerProps) {
  const { t } = useTranslation('settings');

  const { dealOwnerList, isLoading } = useDealOwnerList({
    select: (data) => toDropdownList(data),
  });

  return (
    <FormFieldDropdown
      label={t('label.dealOwner')}
      placeholder={t('label.placeholder.dealOwner')}
      {...props}
      name={name}
      options={dealOwnerList || []}
      loading={isLoading}
    />
  );
}
SelectDealOwner.displayName = 'SelectDealOwner';
